import { AutocompleteInput } from "@sinch/components/form/AutocompleteInput/AutocompleteInput";
import { useQueryHandler } from "@sinch/hooks/useQueryHandler";
import { mapToOptions } from "@sinch/utils/option";
import { isNotNil } from "ramda-adjunct";
import React, { useMemo } from "react";
import { CountriesList } from "./query.graphql";
import { CountriesListQuery } from "./query.types";
import { AutocompleteInputProps, AutocompleteOptions } from "@sinch/components/form/AutocompleteInput/types";
import { isNil } from "ramda";

export interface CountrySelectProps<DisableClearable extends boolean | undefined = undefined>
  extends Omit<
    AutocompleteInputProps<AutocompleteOptions, false, DisableClearable>,
    "value" | "onChange" | "ref" | "options"
  > {
  value: string | null | undefined;
  onChange: (value: string | null) => void;
}

export const CountrySelect = <DisableClearable extends boolean | undefined = undefined>({
  value,
  onChange,
  ...props
}: CountrySelectProps<DisableClearable>) => {
  const { data, loading } = useQueryHandler<CountriesListQuery>(CountriesList);
  const options = useMemo(() => mapToOptions("code", "name")(data?.countries ?? []), [data?.countries]);

  return (
    <AutocompleteInput<AutocompleteOptions, false, DisableClearable>
      {...props}
      disabled={props.disabled || loading}
      loading={loading}
      onChange={(val) => onChange(val === null ? null : String(val))}
      options={options}
      skeleton={props.skeleton || (!isNil(value) && loading)}
      value={isNotNil(value) ? String(value) : null}
    />
  );
};
